module.exports = "data:text/markdown;base64,IyMjIE91dGJvdW5kIENhbGxzOgpBIGNhbGwgZnJvbSBvdXIgcGhvbmUgbnVtYmVyIHRvIGEgcHJvc3BlY3QuCg=="